import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  gender: {
    id: 'ProfileVitals.gender',
    defaultMessage: 'Gender',
  },
  female: {
    id: 'ProfileVitals.female',
    defaultMessage: 'Woman',
  },
  male: {
    id: 'ProfileVitals.male',
    defaultMessage: 'Man',
  },
  nonBinary: {
    id: 'ProfileVitals.nonBinary',
    defaultMessage: 'Non-binary / genderqueer',
  },
  selfIdentifying: {
    id: 'ProfileVitals.selfIdentifying',
    defaultMessage: 'I prefer to self-identify',
  },
  unspecified: {
    id: 'ProfileVitals.unspecified',
    defaultMessage: 'I’d rather not say',
  },
  dateOfBirth: {
    id: 'ProfileVitals.dateOfBirth',
    defaultMessage: 'Date of birth',
  },
  weight: {
    id: 'ProfileVitals.weight',
    defaultMessage: 'Weight (in lbs)',
  },
  clear: {
    id: 'ProfileVitals.clear',
    defaultMessage: 'clear',
  },
});
